import { registerPlugin } from '@capacitor/core';
import { isNative } from '@/utils/platform';

interface SharedStoragePlugin {
  set(options: { key: string; value: string | null }): Promise<void>;
  get(options: { key: string }): Promise<{ value: string | null }>;
  remove(options: { key: string }): Promise<void>;
  clear(): Promise<void>;
  getDeviceId(): Promise<{ value: string }>;
}

const SharedStorage = registerPlugin<SharedStoragePlugin>('SharedStorage');

export const sharedStorage = {
  async set(key: string, value: string | null): Promise<void> {
    if (!isNative()) return;
    try {
      await SharedStorage.set({ key, value });
    } catch (e) {
      console.warn('[sharedStorage] set failed', e);
    }
  },

  async get(key: string): Promise<string | null> {
    if (!isNative()) return null;
    try {
      const { value } = await SharedStorage.get({ key });
      return value ?? null;
    } catch (e) {
      console.warn('[sharedStorage] get failed', e);
      return null;
    }
  },

  async remove(key: string): Promise<void> {
    if (!isNative()) return;
    try {
      await SharedStorage.remove({ key });
    } catch (e) {
      console.warn('[sharedStorage] remove failed', e);
    }
  },

  async clear(): Promise<void> {
    if (!isNative()) return;
    try {
      await SharedStorage.clear();
    } catch (e) {
      console.warn('[sharedStorage] clear failed', e);
    }
  },

  async getDeviceId(): Promise<string | null> {
    if (!isNative()) return null;
    try {
      const { value } = await SharedStorage.getDeviceId();
      return value && value.length > 0 ? value : null;
    } catch (e) {
      console.warn('[sharedStorage] getDeviceId failed', e);
      return null;
    }
  },
};
